// TestimonialSection.tsx
import React from "react";
import useSlider from "@hooks/useSlider";
import Image from "next/image";

interface TestimonialSectionPropsArray {
    title: string;
    img: string;
    desc: string;
}

interface TestimonialSectionProps {
    TestimonialSectionPropsData: TestimonialSectionPropsArray[];
}

const TestimonialSection: React.FC<TestimonialSectionProps> = (props) => {
    const { TestimonialSectionPropsData = [] } = props;
    const { loaded, refCallback, currentSlide, slider } = useSlider();
    return (
        <div className="px-4 lg:hidden pt-10 ">
            <div className="text-center font-bold">
                <span className="text-gray-700 text-2xl">Turn your WhatsApp</span>
                <span className="text-blue-500 text-2xl"> conversations</span>
                <span className="text-gray-700 text-2xl"> into</span>
                <span className="text-blue-500 text-2xl"> revenue</span>
            </div>

            <section className="section-testimonial bg-blue-50 mx-auto shadow-2xl rounded-3xl mt-10">
                <div ref={refCallback} className="keen-slider" style={{ height: "90%" }}>
                    {TestimonialSectionPropsData.map((data, index) => (
                        <div className="keen-slider__slide slider-card relative" key={index}>
                            <div className="flex flex-col h-full p-8">
                                <div className="mb-10">
                                    <Image width={273} height={322} src={data.img} className="w-full" alt="" />
                                </div>
                                <div className="flex justify-center p-2">
                                    <h3 className="text-2xl text-center">{data.title}</h3>
                                </div>
                                <div className="">
                                    <p className="text-center text-base text-gray-500">{data.desc}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {loaded && slider.current && (
                    <div className="carousal-dots pb-8">
                        {[...Array(slider.current.track.details.slides.length).keys()].map((idx) => (
                            <button
                                key={idx}
                                onClick={() => {
                                    slider.current?.moveToIdx(idx);
                                }}
                                className={"carousal-dot" + (currentSlide === idx ? " active" : "")}
                            ></button>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
};

export default TestimonialSection;
